import { render, staticRenderFns } from "./GenerationCard.vue?vue&type=template&id=11240092&scoped=true"
import script from "./GenerationCard.vue?vue&type=script&lang=js"
export * from "./GenerationCard.vue?vue&type=script&lang=js"
import style0 from "./GenerationCard.vue?vue&type=style&index=0&id=11240092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11240092",
  null
  
)

export default component.exports